import { useState } from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Done as DoneIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import ModalConfirmation from '../../layout/ModalConfirmation';
import { usePermission } from '../../lib/usePermission';
import { PermissionRequirement } from '../../lib/permissions';

type SttButtonRecoverProps = {
    caption?: string;
    block?: boolean;
    onClick?: () => void | Promise<void>;
    confirmation?: boolean;
    /** Permiso v8 que hace falta para ver el botón. Sin él, se ve siempre. */
    permission?: PermissionRequirement;
} & Omit<ButtonProps, 'onClick'>;

/**
 * Button recover
 */
export function SttButtonRecover({
    caption,
    permission,
    onClick,
    confirmation = false,
    ...rest
}: SttButtonRecoverProps) {
    const { t } = useTranslation();
    const [confirmationDialog, setConfirmationDialog] = useState({
        show: false,
    });
    const { can } = usePermission();

    if (permission && !can(permission)) return null;

    return (
        <>
            <Button
                {...rest}
                variant="contained"
                color="primary"
                startIcon={<DoneIcon />}
                onClick={
                    confirmation
                        ? () => setConfirmationDialog({ show: true })
                        : onClick
                }
                style={{
                    backgroundColor: 'orange',
                }}
            >
                {caption || t('ui.recover')}
            </Button>

            <ModalConfirmation
                show={confirmationDialog.show}
                onClose={() => setConfirmationDialog({ show: false })}
                onAccept={() => {
                    onClick?.();
                    setConfirmationDialog({ show: false });
                }}
            />
        </>
    );
}
